import type {PropertyDefinition} from '@github-ui/custom-properties-types'
import {useLocation} from '@github-ui/react-router'

export function useSuggestedDefinition() {
  const location = useLocation()
  return location.state?.suggestedDefinition as Omit<PropertyDefinition, 'source'> | undefined
}
